module.exports = __webpack_public_path__ + "img/recharge.7a31519e.png";